var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobHomeGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 3.3125C14.4327 2.98794 14.9591 2.8125 15.5 2.8125C16.0409 2.8125 16.5673 2.98794 17 3.3125L25.75 9.875C26.0605 10.1079 26.3125 10.4098 26.4861 10.757C26.6596 11.1041 26.75 11.4869 26.75 11.875V23.75C26.75 24.413 26.4866 25.0489 26.0178 25.5178C25.5489 25.9866 24.913 26.25 24.25 26.25H18.125C17.7603 26.25 17.4106 26.1051 17.1527 25.8473C16.8949 25.5894 16.75 25.2397 16.75 24.875V17.5C16.75 17.1685 16.6183 16.8505 16.3839 16.6161C16.1495 16.3817 15.8315 16.25 15.5 16.25C15.1685 16.25 14.8505 16.3817 14.6161 16.6161C14.3817 16.8505 14.25 17.1685 14.25 17.5V24.875C14.25 25.0556 14.2144 25.2344 14.1453 25.4012C14.0762 25.568 13.975 25.7196 13.8473 25.8473C13.7196 25.975 13.568 26.0762 13.4012 26.1453C13.2344 26.2144 13.0556 26.25 12.875 26.25H6.75C6.08696 26.25 5.45107 25.9866 4.98223 25.5178C4.51339 25.0489 4.25 24.413 4.25 23.75V11.875C4.25 11.4869 4.34036 11.1041 4.51393 10.757C4.6875 10.4098 4.93951 10.1079 5.25 9.875L14 3.3125ZM15.5 5.3125L6.75 11.875V23.75H11.75V17.5C11.75 16.5054 12.1451 15.5516 12.8483 14.8483C13.5516 14.1451 14.5054 13.75 15.5 13.75C16.4946 13.75 17.4484 14.1451 18.1517 14.8483C18.8549 15.5516 19.25 16.5054 19.25 17.5V23.75H24.25V11.875L15.5 5.3125Z",
    fill: "#808080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobHomeGray);
export default __webpack_public_path__ + "static/media/mob-home-gray.e27f7d36934fd8a79d44893c49f7a438.svg";
export { ForwardRef as ReactComponent };